export const ADD_ALL_CONNECTIONS = "ADD_ALL_CONNECTIONS";
export const CLEAR_CONNECTION_DATA = "CLEAR_CONNECTION_DATA";
